import { render, staticRenderFns } from "./purchase-action.vue?vue&type=template&id=6e19b05e&"
import script from "./purchase-action.vue?vue&type=script&lang=js&"
export * from "./purchase-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports